// if (typeof BSS_B2B !== "undefined") {
//   let found = false;

//   const waitForCartDrawer = setInterval(() => {
//     const targetNode = document.querySelector('#CartDrawer');

//     if (targetNode && !found) {
//       found = true;
//       clearInterval(waitForCartDrawer);

//       const observer = new MutationObserver((mutationsList) => {
//         for (const mutation of mutationsList) {
//           if (mutation.target.id === "CartDrawer") {
//               BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
//               BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
//           }
//         }
//       });

//       const config = {
//         attributes: true,
//         attributeFilter: ['style'],
//         childList: true,
//         subtree: true
//       };

//       observer.observe(targetNode, config);
//     }
//   }, 300);

//   setTimeout(() => {
//     if (!found) {
//       clearInterval(waitForCartDrawer);
//     }
//   }, 8000);


//    setTimeout(() =>{
//       let quickViewBtn = document.querySelectorAll('.button-quickview-icon,.button--quickview');
//       console.log({quickViewBtn})
//       if (quickViewBtn.length) {
//           for (let i = 0; i < quickViewBtn.length; i++) {
//               quickViewBtn[i].onclick = function () {
//                   setTimeout(function () {
//                     const variantInput = document.querySelector("#quickview-product-content input[name='id']");
//                       BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), '#QuickView .main-product-price', false, true, Number(variantInput.value));
                      
//                      const changeVariant = mutations => {
//                                   console.log(2333)
//                                   const valueVariant = variantInput.value
//                                   console.log("valueVariant ", valueVariant)
//                                   setTimeout(() => {
//                                       BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-product-active]", false, true, valueVariant);
//                                   }, 500);
                             
//                       };
//                       const observer = new MutationObserver(changeVariant);
//                       observer.observe(variantInput, {
//                           attributes: true,
//                       });
                      
//                   }, 1500);
//               }
//           }
//       }
//     }, 3000)

// }

document.addEventListener("eurus:cart:items-changed", () => {
  BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
   BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
});


 
  






